export default __webpack_public_path__ + "static/media/resume.6515fad1.pdf";